import script from "./MattersFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./MattersFilters.vue?vue&type=script&setup=true&lang=ts"

import "./MattersFilters.vue?vue&type=style&index=0&id=b33f80ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b33f80ec"]])

export default __exports__